/** Matches App.js public header spacer breakpoints/heights. */
export const PUBLIC_HEADER_SPACER_HEIGHT_PX = 40;
export const PUBLIC_HEADER_SPACER_DESKTOP_HEIGHT_PX = 82;
export const PUBLIC_HEADER_SPACER_DESKTOP_MIN_WIDTH_PX = 1024;

export const DARK_HERO_HEADER_HEIGHT_PX = 68;
export const DARK_HERO_HEADER_XL_HEIGHT_PX = 78;

/** Marketing pages whose hero is full-bleed under the fixed dark-hero header. */
export const DARK_HERO_FULL_BLEED_PATHS = new Set([
  "/",
  "/anti-cheat",
  "/faq",
  "/about-us",
  "/how-it-works",
  "/pricing",
  "/reputation",
  "/trust-and-safety",
  "/support",
]);

/** Full-bleed dark-hero routes skip the layout spacer (same as homepage). */
export function shouldHidePublicHeaderSpacer(pathname, codename) {
  return codename === "dark-hero" && DARK_HERO_FULL_BLEED_PATHS.has(pathname);
}
